<div *ngIf="isInternalStory" class="visibility-overlay overlay-grey">internal story</div>
<div *ngIf="isPrivateStory" class="visibility-overlay overlay-third">private story</div>
<div *ngIf="isPublicStory" class="visibility-overlay overlay-primary">public story</div>
<div *ngIf="isCaseStudy" class="visibility-overlay overlay-secondary">case study</div>
<div *ngIf="isDraft" class="visibility-overlay overlay-red">draft</div>
